<div id="content" class="main-content">
    <div class="container">
        <div class="col-12 pl-0">
           <div class="crumbs breadcrumbs-style-2">
              <ul class="breadcrumb">
                 <li class="mt-3"><a routerLink="/dashboard"><i class="flaticon-home-fill"></i></a>
                 </li>
                 <li class="mt-3"><a routerLink="/surveys-list">Enquêtes</a></li>
                 <li class="active mt-3 current_arian"><a href="javascript:void(0);" class="current_arian">Enquête standard</a></li>
              </ul>
           </div>
        </div>
        <div class="page-header">
            <div class="page-title mt-3 row col-lg-12 col-md-12 d-flex justify-content-between">
               <h1>Enquête : <b>Standard</b></h1>
            </div>
         </div>
       <div class="layout-spacing">
            <div class="widget-content widget-content-area pl-0 pr-1">
                <div class="page-header">
                    <div class="page-title mt-3 row col-lg-12 col-md-12 d-flex justify-content-center">
                    <h2 style="color:black">
                        <img src="../assets/img/suivitim_img/logo_menu.png" width="200">
                    </h2>
                    </div>
                </div>
                <div class="mx-4">
                    <div *ngIf="laoding" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 7%;margin-bottom: 1%;"></div> 
                    <div  *ngIf="!laoding"  class="container mt-5">
                        <div *ngFor="let question of questions" class="row d-flex justify-content-center mb-5 mt-5">
                            <div *ngIf="question.type != 'fr'" class="col-lg-6 col-md-6 col-sm-12 col-xs-12">{{ question.qst }}</div>
                            <ng-container *ngIf="question.type === 'st'">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="display: block;">
                                    <ul>
                                        <li class="col-2 step-item-line mr-1 list-inline-item pr-md-0" *ngFor="let i of [1, 2, 3]">
                                            <i class="flaticon-star-fill"></i>
                                        </li>
                                        <li class="col-2 step-item-line mr-1 list-inline-item pr-md-0" *ngFor="let i of [ 4, 5]">
                                            <i class="flaticon-star-outline"></i>
                                        </li>
                                    </ul>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="question.type === 'ch'">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="display: flex; justify-content: space-evenly">
                                    <div *ngFor="let choice of question.choices">
                                        <label class="new-control new-checkbox new-checkbox-rounded checkbox-success">
                                            <input type="checkbox" disabled [checked]="choice === 'oui'" class="new-control-input">
                                            <span class="new-control-indicator"></span>{{ choice }}
                                        </label>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="question.type === 'fr'">
                                <div class="row col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-5 mt-5">
                                    {{ question.qst }}
                                </div>
                                <div class="row col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-5">
                                    <textarea readonly class="form-control pl-3 pr-3" rows="2" placeholder="Saisir Votre commentaire"></textarea>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
       </div>
    </div>
</div>